import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { CardCarousel } from '../Carousel/CardCarousel';
import { NextArrowFrosted, PrevArrowFrosted } from '../Carousel/CarouselArrows';
import HomePageSection from './HomePageSection';

const SLIDES_CONFIG = { mobile: 2, tablet: 3, desktop: 4, wide: 5, default: 5 };

type CardSectionProps = {
    title?: React.ReactNode;
    titleAlign?: 'left' | 'center';
    arrowVerticalPosition?: string;
    children: React.ReactNode[];
    overflow?: 'visible' | 'hidden';
};

const CardSection = ({
    title,
    titleAlign,
    arrowVerticalPosition = '50%',
    children,
    overflow = 'hidden',
}: CardSectionProps) => (
    <HomePageSection title={title} titleAlign={titleAlign}>
        <CardContainer $overflow={overflow}>
            <CardCarousel
                slidesConfig={SLIDES_CONFIG}
                arrowVerticalPosition={arrowVerticalPosition}
                $gap="8px"
                nextArrow={<NextArrowFrosted />}
                prevArrow={<PrevArrowFrosted />}
            >
                {children}
            </CardCarousel>
        </CardContainer>
    </HomePageSection>
);

const CardContainer = styled.div<{ $overflow?: 'visible' | 'hidden' }>`
    width: 100%;
    .slick-list {
        overflow: ${({ $overflow }) => $overflow};
    }
`;

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`;

export const CardImageLink = styled(Link)`
    display: block;
    width: 100%;
    text-decoration: none;
    color: inherit;
`;

export const CardImageFrame = styled.div<{ $aspectRatio: string }>`
    width: 100%;
    aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
    overflow: hidden;
    border-radius: 16px;
    background-color: ${({ theme }) => theme.colors.fillWhite};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CardImage = styled.img<{ $width?: string; $height?: string }>`
    width: ${({ $width }) => $width ?? 'auto'};
    height: ${({ $height }) => $height ?? '100%'};
    object-fit: contain;
`;

export default CardSection;
